import { Button, Stack } from "@mui/material";
import React, { useState } from "react";
import styled from "styled-components";
import { colors, fontSizes } from "../../theme";
import { useApi } from "../../contexts/ApiContext";

const StyledButtonGroup = styled(Stack)(({ theme }) => ({
  backgroundColor: colors.stone[100],
  padding: 6,
  borderRadius: 10,
  "& button": {
    color: colors.stone[500],
    borderRadius: 5,
    border: 0,
    "&:hover": {
      border: "none",
    },
    "&.selected": {
      color: colors.stone[900],
      backgroundColor: colors.stone[50],
    },
  },
}));

interface ButtonGroupButtonProps {
  label: string;
  onClick: (index: number) => void;
}

interface ButtonGroupProps {
  buttons: ButtonGroupButtonProps[];
  selectedIndex?: number;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({
  buttons,
  selectedIndex: selectedIndexProp = null,
}) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(
    selectedIndexProp
  );

  const { isSubmitting, isLoading } = useApi();
  const isDisabled = isLoading || isSubmitting;

  const handleOnClick = (index: number) => {
    setSelectedIndex(index);
    buttons[index].onClick(index);
  };

  return (
    <StyledButtonGroup direction={"row"} justifyContent={"space-around"}>
      {buttons.map((btn: ButtonGroupButtonProps, index: number) => (
        <Button
          disabled={isDisabled}
          key={index}
          className={index === selectedIndex ? "selected" : ""}
          onClick={() => handleOnClick(index)}
          sx={{ fontSize: fontSizes.sm, fontWeight: "medium" }}
        >
          {btn.label}
        </Button>
      ))}
    </StyledButtonGroup>
  );
};
export default ButtonGroup;
